// @material-ui/core
import { Typography } from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";

const styles = theme => ({
  header: {
    margin: "16px 0"
  }
});

class PageHeader extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string
  };

  render() {
    const { classes, title, description } = this.props;
    return (
      <div className={classes.header}>
        <Typography variant="headline">{title}</Typography>
        <Typography variant="subheading">{description}</Typography>
      </div>
    );
  }
}

export default withStyles(styles)(PageHeader);



// WEBPACK FOOTER //
// ./src/library/pages/PageHeader.js